<div class="in_vitro_fertilization header_top mb-5">
  <section class="treatment_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Preimplantation Genetic Testing (PGT)</h6>
        <h5>Take the next step toward a healthy pregnancy</h5>
        <p>
          Take the next step toward a healthy pregnancy Give your IVF journey
          the best start with Preimplantation Genetic Testing (PGT) at NCare IVF
          in Kannur. Our advanced screening process helps select genetically
          healthy embryos, reducing the risk of inherited disorders and
          improving IVF success rates.
        </p>
        <button [routerLink]="['/contact-us']">Book a Consultation</button>
      </div>
    </div>
  </section>
  <section class="how_does_work_ivf mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            loading="lazy"
            src="../../assets/images/treatment/how_ivf.webp"
            alt=""
          />
        </div>
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h6>Preimplantation Genetic Testing</h6>
          <p>
            A Smarter Approach to IVF Preimplantation Genetic Testing (PGT) is a
            method used during In Vitro Fertilization (IVF) to check embryos for
            genetic abnormalities before implantation. This process helps select
            genetically healthy embryos, reducing the chances of miscarriage and
            inherited conditions while improving the likelihood of a successful
            pregnancy.
          </p>
          <p>
            At NCare IVF Kannur, Kerala, we provide precise genetic screening to
            support couples who may have a family history of genetic conditions,
            recurrent miscarriages, or unsuccessful IVF attempts. By identifying
            potential concerns early, PGT helps ensure a smoother fertility
            journey with better outcomes.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <!-- <h5>CTA Banner</h5> -->
        <p>
          Considering PGT for your IVF treatment? Schedule a consultation with
          our experts to understand how genetic testing can support your
          fertility journey.
        </p>
        <button [routerLink]="['/contact-us']">Book Now</button>
      </div>
    </div>
  </section>
  <section class="how_does_ivf_process_work mt-5">
    <div class="container">
      <h4 class="title_header tac">
        How Preimplantation Genetic Testing (PGT) Works
      </h4>
      <p class="title_para">
        Preimplantation Genetic Testing (PGT) is a multi-step process conducted
        during an IVF cycle to ensure only healthy embryos are selected for
        implantation. Each stage is carefully performed to maximize success
        rates while maintaining embryo integrity.
      </p>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="1">
          <img
            loading="lazy"
            src="../../../../assets/images/pgt/hpgtw_1.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 1: IVF and Embryo Development</h5>
          <p>
            Eggs are retrieved from the ovaries and fertilized with sperm in a
            controlled laboratory environment. The resulting embryos are
            monitored for 5-6 days until they reach the blastocyst stage, the
            ideal phase for genetic testing.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="2">
          <h5>Step 2: Embryo Biopsy for Genetic Analysis</h5>
          <p>
            A microscopic biopsy is performed on each embryo, where a small
            number of cells are carefully removed. This step is conducted using
            precise techniques to ensure the embryo remains unaffected and
            continues developing normally.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/pgt/hpgtw_2.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="3">
          <img
            loading="lazy"
            src="../../../../assets/images/pgt/hpgtw_3.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 3: Comprehensive Genetic Screening</h5>
          <p>
            The extracted cells undergo genetic analysis, where specialists
            examine them for chromosomal abnormalities, single-gene disorders,
            structural rearrangements, polygenic risk factors (PGT-P), or via
            non-invasive screening (niPGT).
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="4">
          <h5>Step 4: Selection of Genetically Healthy Embryos</h5>
          <p>
            Once the analysis is complete, only chromosomally normal and
            genetically healthy embryos are selected for transfer.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <img
            loading="lazy"
            src="../../../../assets/images/pgt/hpgtw_4.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 ls" data-step="5">
          <img
            loading="lazy"
            src="../../../../assets/images/pgt/hpgtw_5.webp"
            alt=""
          />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Step 5: Embryo Transfer and Pregnancy Testing</h5>
          <p>
            A carefully selected healthy embryo is transferred into the uterus,
            increasing the likelihood of implantation and a successful
            pregnancy. A pregnancy test is conducted 12-14 days after embryo
            transfer to confirm the outcome.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="benefits-section">
    <h2 class="title_header tac">Benefits of PGT at NCare IVF</h2>
    <ul class="benefits-list">
      <li>
        <span class="icon">🌟</span>
        Improves the chances of a healthy pregnancy
      </li>
      <li>
        <span class="icon">🛡️</span>
        Reduces the risk of miscarriage and genetic disorders
      </li>
      <li>
        <span class="icon">👨‍👩‍👧</span>
        Supports informed family planning decisions
      </li>
    </ul>
  </section>
  <section class="types_preimplantation_genetic_testing">
    <div class="container">
      <h1 class="title_header tac">
        Types of Preimplantation Genetic Testing (PGT)
      </h1>
      <p class="intro">
        Preimplantation Genetic Testing (PGT) includes various screening
        methods, each designed to address specific genetic concerns. Selecting
        the right test based on individual medical history and fertility goals
        improves the chances of a successful pregnancy.
      </p>

      <div class="card">
        <h2 class="title_header tac">
          PGT-A: Screening for Chromosomal Abnormalities
        </h2>
        <p>
          PGT-A helps detect missing or extra chromosomes in embryos.
          Chromosomal imbalances may lead to conditions such as Down syndrome,
          Turner syndrome, and Edwards syndrome, which can affect pregnancy
          success.
        </p>
        <h3>Who Benefits from PGT-A?</h3>
        <ul>
          <li>
            Women over the age of 35 who have a higher risk of chromosomal
            abnormalities
          </li>
          <li>Couples who have experienced multiple miscarriages</li>
          <li>Individuals with a history of unsuccessful IVF cycles</li>
        </ul>
      </div>

      <div class="card">
        <h2 class="title_header tac">PGT-M: Detecting Single-Gene Disorders</h2>
        <p>
          PGT-M identifies embryos affected by inherited genetic conditions
          caused by mutations in a single gene. This test helps couples with a
          known history of genetic disorders reduce the risk of passing these
          conditions to their child.
        </p>
        <h3>Genetic Conditions Detected by PGT-M:</h3>
        <ul>
          <li>Thalassemia</li>
          <li>Cystic Fibrosis</li>
          <li>Sickle Cell Disease</li>
          <li>BRCA-related hereditary cancers</li>
        </ul>
      </div>

      <div class="card">
        <h2 class="title_header tac">
          PGT-SR: Identifying Structural Chromosomal Rearrangements
        </h2>
        <p>
          PGT-SR is designed for individuals with chromosomal structural
          variations, such as translocations, inversions, or deletions. These
          genetic changes can lead to implantation failure, pregnancy loss, or
          birth defects.
        </p>
        <h3>Why Consider PGT-SR?</h3>
        <ul>
          <li>
            Detect structural abnormalities that may affect embryo viability
          </li>
          <li>Reduce the risk of implantation failure or miscarriage</li>
          <li>Improve the chances of a healthy and successful pregnancy</li>
        </ul>
      </div>

      <div class="card">
        <h2 class="title_header tac">
          PGT-P: Testing for Polygenic Conditions
        </h2>
        <p>
          PGT-P is a cutting-edge test that screens embryos for polygenic
          conditions — conditions influenced by multiple genes and lifestyle
          factors. These include common diseases like heart disease, type 2
          diabetes, and certain cancers.
        </p>
        <h3>Benefits of PGT-P:</h3>
        <ul>
          <li>Provides a genetic risk profile for complex diseases</li>
          <li>
            Helps select embryos with a lower genetic risk for common health
            issues
          </li>
          <li>Supports long-term health planning for future generations</li>
        </ul>
      </div>

      <div class="card">
        <h2 class="title_header tac">
          niPGT: Non-Invasive Preimplantation Genetic Testing
        </h2>
        <p>
          niPGT is a non-invasive testing method that analyzes cell-free DNA
          released by embryos into the culture medium. It offers genetic
          screening without embryo biopsy.
        </p>
        <h3>Advantages of niPGT:</h3>
        <ul>
          <li>Completely non-invasive and embryo-safe</li>
          <li>Helps identify chromosomally normal embryos</li>
          <li>Ideal for patients who wish to avoid embryo biopsy</li>
        </ul>
      </div>

      <div class="card">
        <h2 class="title_header tac">
          Who Should Consider Preimplantation Genetic Testing (PGT)?
        </h2>
        <p>
          Preimplantation Genetic Testing (PGT) helps identify genetic
          abnormalities before embryo implantation, ensuring a healthier
          pregnancy. While not required for every IVF cycle, it is highly
          recommended for individuals or couples with specific medical
          histories.
        </p>
        <h3>Ideal Candidates for PGT:</h3>
        <ul>
          <li>Couples with a history of genetic disorders</li>
          <li>Women over 35</li>
          <li>Couples who have experienced recurrent miscarriages</li>
          <li>Individuals with previous IVF failures</li>
          <li>Men with genetic infertility concerns</li>
          <li>Patients considering family balancing</li>
        </ul>
        <p>
          Our fertility specialists provide expert genetic counseling, helping
          couples understand the benefits of PGT and whether it is the right
          choice for their journey to parenthood.
        </p>
      </div>
    </div>
  </section>

  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h4 class="title_header tac">
        Benefits of Preimplantation Genetic Testing (PGT) at NCare IVF
      </h4>

      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/bpgt_1.svg"
              alt=""
            />
            <h5>Improved IVF Success Rates</h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/bpgt_2.svg"
              alt=""
            />
            <h5>Reduced Risk of Miscarriage</h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/bpgt_3.svg"
              alt=""
            />
            <h5>Prevention of Inherited Genetic Disorders</h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/bpgt_4.svg"
              alt=""
            />
            <h5>Healthier Pregnancy Outcomes</h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/bpgt_5.svg"
              alt=""
            />
            <h5>Better Family Planning Options</h5>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="what_we_provide mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img
            loading="lazy"
            src="../../assets/images/treatment/what_we_provide.webp"
            alt=""
          />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6>
            Success Rates of IVF with Preimplantation Genetic Testing (PGT)
          </h6>
          <ul>
            <li><span>Higher Implantation Rates</span> - 60-70% per cycle</li>
            <li>
              <span>Lower Miscarriage Risk</span> – From 20-25% down to below
              10%
            </li>
            <li><span>Improved Live Birth Rates</span></li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h4 class="title_header tac">
        Why Choose NCare IVF for Preimplantation Genetic Testing (PGT)?
      </h4>

      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/pgt_1.svg"
              alt=""
            />
            <h5>Advanced Genetic Testing Lab</h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/pgt_2.svg"
              alt=""
            />
            <h5>Experienced Specialists</h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/pgt_3.svg"
              alt=""
            />
            <h5>
              Comprehensive Screening (PGT-A, PGT-M, PGT-SR, PGT-P, and niPGT)
            </h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/pgt_4.svg"
              alt=""
            />
            <h5>Safe & Ethical Procedures</h5>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../../assets/images/pgt/pgt_5.svg"
              alt=""
            />
            <h5>Convenient Location in Kannur</h5>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Does PGT guarantee a successful pregnancy?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              PGT improves success rates but does not guarantee pregnancy.
              Factors like uterine health also matter.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Is PGT safe for embryos?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Yes, with advanced techniques, embryo biopsy or niPGT does not
              harm development.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Can PGT detect all genetic disorders?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              PGT detects many but not all potential conditions.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              How much does PGT cost in Kannur?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Costs vary based on the type of PGT. Our experts will guide you
              with a personalized plan.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              Is PGT recommended for all IVF patients?
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              It’s recommended for specific cases like recurrent miscarriages,
              IVF failures, or genetic history.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
